import { z } from 'zod/mini'

import { nonEmptyString } from './non-empty-string'

export const promotionSchema = z.strictObject({
  creative_name: nonEmptyString(),
  creative_slot: nonEmptyString(),
  promotion_id: z.optional(nonEmptyString()),
  promotion_name: z.optional(nonEmptyString()),
})
